import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {
    searchProcess,
    updateWorkProcess,
    clear_work_process,
    UPDATE_WORK_PROCESS,
} from "../../../redux/work_process";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import { CREATE_WORK_SUBPROCESS, createWorkSubProcess, clear_work_subprocess } from "../../../redux/work_subprocess";
import { getAllWorkSheets } from "../../../redux/work_sheets";

const UpdateWorkProcess = () => {
    let history = useHistory();
    const {id_work_sheet, id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _create_work_subprocess = useSelector((state) => state.work_subprocess_module._create_work_subprocess);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [subprocess, setSubProcess] = useState('');

    const _update_work_process = useSelector((state) => state.work_process_module._update_work_process);

    const [form, setForm] = useState({
        nombre: "",
        id_hoja_trabajo: 0,
        hoja_trabajo: "",
        activo: true,
        subprocesos: [],
    });

    async function get_process() {
        // eslint-disable-next-line
        let params = "?id=" + id;
        try {
            const response = await searchProcess(token, params);
            if (response && response.data && response.data.cantidad > 0) {
                let data = response.data.datos[0];
                setForm(data);
            }
        } catch (e) {
            console.log('Error')
        }
    }

    useEffect(() => {
        get_process();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (_update_work_process.status === 200) {
            dispatch(clear_work_process(UPDATE_WORK_PROCESS));
            history.push(`/hoja-trabajo/detalle/${id_work_sheet}`);
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
        } else if (_update_work_process.status !== 0) {
            dispatch(clear_work_process(UPDATE_WORK_PROCESS));
            toast.error(_update_work_process.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_work_process, dispatch, history, token, id_work_sheet]);

    
    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateWorkProcess(token, id, form));
    };

    useEffect(() => {
        if (_create_work_subprocess.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_subprocess(CREATE_WORK_SUBPROCESS));
            dispatch(getAllWorkSheets(token));
            get_process();
            setIsLoading(false);
            setModal(false);
        } else if (_create_work_subprocess.status !== 0) {
            dispatch(clear_work_subprocess(CREATE_WORK_SUBPROCESS));
            toast.error(_create_work_subprocess.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_subprocess, dispatch, history, token]);

    const handleSubmitSubProcess = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (subprocess === '') {
            toast.error("Debe ingresar un subproceso", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createWorkSubProcess(token, {nombre: subprocess, id_proceso: id}));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hojas de trabajos"
                            items={[
                                {label: "Detalles", link: "/hojas-trabajos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar proceso</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Hoja de trabajo</label>
                                                <SelectInput
                                                    label="hoja_trabajo"
                                                    name="id_hoja_trabajo"
                                                    value={form.id_hoja_trabajo}
                                                    select={form.hoja_trabajo}
                                                    disabled={true}
                                                    options={[{
                                                        name: form.hoja_trabajo,
                                                        id: form.id_hoja_trabajo,
                                                    }]}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Subprocesos</p>
                                            <p className="text-body">Sección para asignar los subprocesos que conforman
                                                el proceso seleccionado</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1"
                                                    onChange={() => {
                                                        setModal(true);
                                                        setSubProcess('');
                                                    }}/>
                                        </div>
                                        {form.subprocesos.length > 0 && (
                                            form.subprocesos.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                                <strong
                                                                    className="texto_16">Actividades: {item.actividades}</strong><br/>
                                                                <span
                                                                    className="texto_14">{item.activo ? 'Activo' : 'Inactivo'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="text-right mt-2" style={{width: '10%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/edit.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    history.push(`/subproceso-trabajo/detalle/${id_work_sheet}/${id}/${item.id}`);
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Button text="Cancelar" onChange={() => {
                                            history.push(`/hoja-trabajo/detalle/${id_work_sheet}`);
                                        }} className="btn btn-outline-dark magin_button button_responsible"/>

                                        <Button type="submit" text="Guardar" theme="calendar" classes="button_responsible"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitSubProcess}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar subproceso</h5>
                        <div className="form-group">
                        <Input
                                name="subproceso"
                                label="subproceso"
                                value={subprocess}
                                onChange={(e) => {setSubProcess(e.target.value)}}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateWorkProcess;
